import { Button } from "@growtherapy/sprout-ui";
import { useSetAtom } from "jotai";
import { useCallback } from "react";
import type { PageComponentProps } from "../../../../components";
import { visitorDrawerStateAtom } from "../../../../visitor/state";
import {
  useMoodCheckinSelectionsState,
  useMoodCheckinCustomResponseState,
} from "./useMoodCheckinSelectionsState";
import { useSyncMoodCheckinChoicesCallback } from "./useSyncMoodCheckinChoicesCallback";
import { usePreSessionPromptState } from "../../../waiting-room/pre-session-prompt/usePreSessionPromptState";
import {
  MOOD_SURVEY_PREVIOUS_BUTTON_TEXT,
  MOOD_SURVEY_SAVE_AND_CLOSE_BUTTON_TEXT,
} from "./lang";

export function Actions({
  isFirstPage,
  prevPage,
}: PageComponentProps<string[]>) {
  const [selections] = useMoodCheckinSelectionsState();
  const [customResponse, setCustomResponse] =
    useMoodCheckinCustomResponseState();
  const onSyncChoices = useSyncMoodCheckinChoicesCallback();
  const setDrawerState = useSetAtom(visitorDrawerStateAtom);
  const { clearPreSessionPrompt } = usePreSessionPromptState();

  const onSaveAndCloseDrawer = useCallback(() => {
    const emotionsToSync = customResponse.trim()
      ? [...selections, customResponse.trim()]
      : selections;

    if (!emotionsToSync.length) return;

    onSyncChoices(emotionsToSync, {
      onCompleted() {
        setCustomResponse("");
        setDrawerState(null);
        clearPreSessionPrompt();
      },
    });
  }, [
    onSyncChoices,
    selections,
    customResponse,
    setCustomResponse,
    setDrawerState,
    clearPreSessionPrompt,
  ]);

  return (
    <>
      {!isFirstPage && (
        <Button onClick={prevPage} use="secondary">
          {MOOD_SURVEY_PREVIOUS_BUTTON_TEXT}
        </Button>
      )}
      <Button onClick={onSaveAndCloseDrawer}>
        {MOOD_SURVEY_SAVE_AND_CLOSE_BUTTON_TEXT}
      </Button>
    </>
  );
}
